import "./index.css";

export default function Content({ children }) {
  return <main style={{ minHeight: "75vh" }}>{children}</main>;
}
